export default __webpack_public_path__ + "station-defect-coupling-gray.png?9776bb6c0b0fd2bf449c2a85cef716a9";